import React from 'react';
import {NextState} from '../../types';

export type FiscalYearState = {
    year: string;
    startDate: string;
    endDate: string;
    prevStartDate: string;
    prevEndDate: string;
    prefix: string;
    existYearFlag: boolean;
    subCompanyFlag: boolean;
    nscust: string;
    exttype: string;
};

export type FooterState = {
    isValid: boolean;
    setIsValid: (value: boolean) => void;
    customNextLabel?: string;
    setCustomNextLabel: (value?: string) => void;
    onCloseCallback: () => void;
    onStepComplete: () => void;
    setOnNextState: (value: NextState) => void;
    onNextState: NextState;
    dialogZIndex: number;
    fiscalYearEndDate?: string;
    setFiscalYearEndDate: (value?: string) => void;
    fiscalYearState: {
        state?: FiscalYearState;
        setState: (value: FiscalYearState) => void;
        isLoaded: boolean;
        setIsLoaded: (value: boolean) => void;
    };
};

export const FooterContext = React.createContext<FooterState>({
    isValid: true,
    setIsValid: () => {},
    customNextLabel: undefined,
    setCustomNextLabel: () => {},
    onCloseCallback: () => {},
    onStepComplete: () => {},
    onNextState: NextState.Idle,
    setOnNextState: () => {},
    dialogZIndex: 0,
    fiscalYearEndDate: undefined,
    setFiscalYearEndDate: () => {},
    fiscalYearState: {
        isLoaded: false,
        setState: () => {},
        setIsLoaded: () => {}
    }
});
